import { useQuery } from "@apollo/client";
import React, { useState } from "react";
import claims from "../../../gql/claims";
import { Chip, Tooltip } from "@mui/material";
import AppModal from "../../../components/AppModal";
import ClaimReportModal from "../components/ClaimReportModal";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import axios from "axios";
import { useTranslation } from "react-i18next";
import AppTable from "../../../shared/AppTable";
import AppButton from "../../../shared/AppButton";

export default function ClaimReportMain() {
  const { t, i18n } = useTranslation();
  const [reportOpen, setReportOpen] = useState(false);
  const handleReportOpen = () => {
    setReportOpen(true);
  };

  const handleReportClose = () => {
    setReportOpen(false);
  };
  const {
    loading: dataLoading,
    error,
    data,
    refetch,
  } = useQuery(claims.CLAIMS_REPORT_LIST, {
    fetchPolicy: "no-cache",
    nextFetchPolicy: "no-cache",
  });

  const columns = [
    { header: t("SQ #"), render: (row, index) => index + 1 },
    {
      header: t("Status"),
      render: (row) =>
        row?.status ? (
          <Chip
            label={row?.status}
            color={getColor(row?.status)}
            size="small"
            className="uppercase !text-[10px] !h-[18px]"
          />
        ) : (
          "___"
        ),
    },
    {
      header: t("Request Date"),
      render: (row) => formatDateTime(row?.date_ordered),
    },
    {
      header: t("Payer Name"),
      render: (row) => (
        <span className="whitespace-nowrap">{row?.payer_name || "---"}</span>
      ),
    },
    { header: t("From Date"), render: (row) => formatDateTime(row?.from_date) },
    { header: t("To Date"), render: (row) => formatDateTime(row?.to_date) },
  ];

  const getColor = (status) => {
    if (status === "failed") {
      return "error";
    } else if (status === "completed") {
      return "success";
    } else if (status === "processing") {
      return "info";
    } else {
      return "secondary";
    }
  };

  const formatDateTime = (time) => {
    const dateTime = new Date(time);

    return dateTime.toDateString();
  };

  const handleDownload = async (id) => {
    try {
      const token = localStorage.getItem("token")?.replaceAll('"', "");
      const response = await axios.get(
        `https://api.supergitsa.com/api/claim/excel/report`,
        {
          params: { id: id },
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const contentType = response.headers["content-type"];
      const fileExtension = contentType.includes("pdf") ? "pdf" : "xlsx";
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `report.${fileExtension}`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error(t("Error downloading the file:"), error);
    }
  };

  return (
    <>
      <div className="claimsSubmission_container">
        <div className="claimsSubmission_page !bg-transparent">
          <div className="flex justify-between flex-col lg:flex-row gap-4 mb-2">
            <div className="">
              <Tooltip
                placement="right"
                title={t("Keep track of your claims submissions")}
                className="my-auto !mt-2"
              >
                <span className="font-semibold text-black/70 text-lg ">
                  {t("Claim Reporting")}
                  <span className="text-lg ml-1">
                    ({data?.getClaimsReportList?.data?.length || 0}{" "}
                    <span className="text-xs font-bold italic">
                      {t("Entries")}
                    </span>
                    )
                  </span>
                </span>
              </Tooltip>
            </div>

            <div class=" flex gap-3 flex-col md:flex-row">
              <AppButton
                onClick={() => setReportOpen(true)}
                startIcon={<FileDownloadOutlinedIcon />}
                label={t("Download Report")}
              />
            </div>
          </div>
        </div>

        {/* table */}
        <AppTable
          columns={columns}
          data={data?.getClaimsReportList?.data}
          loading={dataLoading}
          onDownload={(row) => handleDownload(row.id)}
        />
      </div>
      <ClaimReportModal
        open={reportOpen}
        setOpen={setReportOpen}
        handleClose={handleReportClose}
        handleClickOpen={handleReportOpen}
        refetchReport={refetch}
      />
      <AppModal isOpen={dataLoading} />
    </>
  );
}
